import { SubcategoryCirclesUI } from './SubcategoryCirclesUI'
import { useSubcategoryCircles } from './useSubcategoryCircles'
import type { ISubcategoryCircle } from './types'

interface SubcategoryCirclesProps {
  className?: string
}

export const SubcategoryCircles = ({ className }: SubcategoryCirclesProps) => {
  const { subcategories, isLoading, hasSubcategories, isSelectedSubcategory, handleSubcategoryClick } =
    useSubcategoryCircles()

  if (!isLoading && !hasSubcategories) return null

  return (
    <SubcategoryCirclesUI
      subcategories={subcategories}
      isLoading={isLoading}
      isSelectedSubcategory={isSelectedSubcategory}
      onSubcategoryClick={handleSubcategoryClick}
      className={className}
    />
  )
}

export type { ISubcategoryCircle }
